import { Outlet } from 'react-router'
import Header from '../../../component/layout/header'
import useNav from '../../../component/custom-hooks/get-nav';

const PPCDataOrganizationLayout = () => {

  const navList = useNav();
  let {PPCDataTopNav, PPCDataOrgBottomNav} = navList;

  return (
    <div className="webBody">
      <Header bottomTabs={PPCDataOrgBottomNav} topTabs={PPCDataTopNav} />
      <Outlet />
    </div>
  )
}

export default PPCDataOrganizationLayout